export const TOASTIFY_NEWEST_ON_TOP = true;
export const MESSAGES = {
  forgotPasswordSuccess:
		'Your hospital account has not been verified. Please check your email',
  forgotPasswordError: 'Error occurred while verifying the account!',
  registerSuccess: 'Please check your email to verify your hospital account.',
  registerError: 'Error occurred while signing up!',
  loginSuccess: 'You have logged in successfully!',
  loginError: 'Error occurred while logging in!',
  maxFailAttempts: 'Too many failed login attempts. Try again later.'
};
export const BG_IMAGE_URLS = {
  pharmacyauthPage:
		// 'https://img.freepik.com/free-photo/warehouse-pharmacy_1161-231.jpg?ga=GA1.1.1774221313.1717775999&semt=ais_hybrid',
		// 'https://c1.wallpaperflare.com/preview/688/137/178/drugs-medicine-medication-pills.jpg',
		'https://c1.wallpaperflare.com/preview/978/333/122/pharmacy-medicine-food-supplement-health.jpg',
  forgotPasswordPage:
		'https://images.pexels.com/photos/2882630/pexels-photo-2882630.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
  resetPasswordPage:
		'https://images.pexels.com/photos/2882630/pexels-photo-2882630.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
};
